import React, { Component } from 'react';
import Learning from '../../components/Learning/Learning';

class LearningRoute extends Component {
  render() {
    return (
      <section className='container-section'>
        <Learning />
      </section>
    );
  }
}

export default LearningRoute;
